module.exports = __webpack_public_path__ + "35ecdbec656f285a70156249df9f9a93.png";